<template>
  <div class="navbar">
    <div class="flexCenter">
      <i @click='clickI' :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"></i>
      <!-- 面包屑 -->
      <breadcrumb></breadcrumb>
      <!-- 当前登录用户 -->
      <div class="username">
        <a title="coding" href="https://yaguanjia.coding.net/" target="_blank" style="margin-right: 10px;">
          <img src="../../assets/coding.jpg" width="19px" alt="">
        </a>
        <i class="el-icon-user-solid"></i> &nbsp; &nbsp;{{user.UserName}}
       </div>
      <!-- 退出按钮 -->
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/home/index">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="outSystem" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
	import breadcrumb from './breadcrumbPath.vue'
  export default{
    data() {
      return{
				user:{},
        isCollapse:false,
        //头像地址
        circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      }
    },
    components:{ breadcrumb },
		mounted() {
			// console.log(this.UserData);
			this.user = JSON.parse(localStorage.getItem('UserData'))
		},
    methods:{
      clickI(){
        this.isCollapse=!this.isCollapse
        this.$emit('clickNavbar')
      },
      // 退出
      outSystem() {
        // 退出功能主要是利用清除token的原理来实现
        // 清除token
        // localStorage.setItem("userRole", 'unload')
		localStorage.setItem("user_key", "")
		// this.$router.push('/')
		location.reload();
        localStorage.removeItem('user_key')
        // 跳转到登录页的时候顺便刷新
        // window.location.href = window.location.origin + window.location.pathname
      }

    }
  }
</script>

<style scoped>
  .flexCenter{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .navbar{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .userImg{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1px solid #f3f4f6;

    position: absolute;
    right: 100px;
  }
  /* 当前账户 */
  .username{
    width: 200px;
    height: 50px;
    line-height: 50px;
    color: #999999;
    text-align: right;
    overflow: hidden;
    position: absolute;
    right: 100px;
  }
  /* 右侧按钮 */
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 60px;
  }
 .avatar-wrapper {
    cursor: pointer;
    margin-top: 15px;
    position: relative;
  }
  /* .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }
  .el-icon-caret-bottom {
    position: absolute;
    right: -20px;
    top: 25px;
    font-size: 12px;
  } */
</style>
